import React, { useEffect, useState } from 'react'
import { Row, Col, Button, Input, Tooltip } from 'antd'
import { useWeb3React } from '@web3-react/core'
import { Copy } from 'react-feather'
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as web3Service from '../../blockchain/web3.service'

export default function DragonReferralWidget() {

    const { account } = useWeb3React()

    const [referralsLink, setReferralsLink] = useState('')
    const [devFee, setDevFee] = useState(0.00)
    const currentURL = window.location.href

    useEffect(() => {
        let refLink = currentURL + '?ref=' + account
        setReferralsLink(refLink)
    }, [currentURL, account])

    useEffect(() => {
        fetchDevFee()
    }, [])

    const copyReferralAddress = () => {

        navigator.clipboard.writeText(referralsLink)
        toast.success('Referral link copied !')
    }

    const fetchDevFee = async () => {
        const devFeeResponse = await web3Service.getDevFee()
        if (devFeeResponse) {
            const actualDevFee = parseFloat(devFeeResponse) * 2
            setDevFee(actualDevFee || 0)
        } else {
            setDevFee(0.0)
        }
    }

    return (
        <div className='wallet-balance-container'>
            <Row>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <div className='dragon-referral-title mt-3'>
                        Referral Link
                    </div>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='mt-3'>
                    <div className='referral-details d-flex justify-content-center align-items-center mx-3'>
                        Earn {devFee}% of the BNB used to G Dragon from anyone who uses your referral link
                    </div>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='mt-2'>


                    {
                        account ? (
                            <div className='referral-address-container mb-4'>

                                <Input.Group compact>
                                    <Input
                                        style={{ width: 'calc(100% - 200px)' }}
                                        value={referralsLink}
                                    />
                                    <Tooltip title="copy referral address">
                                        <Button onClick={copyReferralAddress}>
                                            <Copy size={20} color="#FE2301" />
                                        </Button>
                                    </Tooltip>
                                </Input.Group>
                            </div>
                        ) : (
                            <div className='hiring-dragon-button-container mb-4'>
                                <Button
                                    className='referral-dragons-btn'
                                    type="primary"
                                    shape="round"
                                >
                                    Connect your wallet to get REFERRAL link
                                </Button>
                            </div>
                        )
                    }
                </Col>
            </Row>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                style={{ textAlign: 'start' }}
                theme="dark"
                limit={2}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    )
}